/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import VisavaLogo from '../../../../src/asset/images/VisavaLogo.png';
import languageLogo from '../../../../src/asset/images/vector.svg';
import SideMenuIcon from '../../../../src/asset/images/side_menu.svg';
import CloseIcon from '../../../../src/asset/images/cancel-icon.svg';
//import PlayStoreImg from '../../../../src/asset/images/playStore.png';
import GooglePlayBadgeEn from '../../../../src/asset/images/GooglePlayBadgeEn.png';
import GooglePlayBadgeHi from '../../../../src/asset/images/GooglePlayBadgeHi.png';
import GooglePlayBadgeMa from '../../../../src/asset/images/GooglePlayBadgeMa.png';
//import Offer_tag_img from '../../../asset/images/offer_tag_img.svg';
import betaOffer from '../../../asset/images/beta_offer.svg';
import Breakpoint from '../../../utility/breakPoints';
//import GetDocumentImg from '../../../../src/asset/images/499-document.png';
//import { constants, hindiConstants, marathiConstants } from '../../../utility/constants';
import { changeLang } from '../../../i18n/i18n';
import { withTranslation } from 'react-i18next';
import Loader from '../Loader';
import PaymentPopup from '../../components/paymentPopup';
import ErrorPopup from '../../components/errorPopup';
import ROUTES from '../../../pages/routes';
import PaymentSuccessPage from '../../components/paymentSuccessPage';
// import { GOOGLE_PLAY_URL, BASE_URL_V4, API_URL, SHARE_URL, BLOG_URL, WebApp_VERSION, userAgent, User_Type } from '../../../api/api-config';     //hide blog url for now
import { GOOGLE_PLAY_URL, BASE_URL_V4, API_URL, SHARE_URL, WebApp_VERSION, userAgent, User_Type, SHOW_HEADER_MY_PROFILE_LINK, SHOW_HEADER_GOOGLE_PLAY_BADGE, FREE_DOCUMENT_FOR_ALL } from '../../../api/api-config';
import { axiosInstance } from '../../../api/coreApi';
import { setInitialPayment } from '../../redux/actions/initiatePayment';
import { updateBreakPoint, updateLangCode } from '../../redux/actions/headerState';
import { getBreakpoint, getLangCodeSelector } from '../../../selectors/commonSelectors';
import { windowOpenHandler } from '../../../utility/common';


class Header extends React.Component {
  constructor (props) {
    super(props);
    this.onEnter=this.onEnter.bind(this);
    this.onLeave=this.onLeave.bind(this);
    this.updateBreakPoint=this.updateBreakPoint.bind(this);
    this.renderSideMenuOptions=this.renderSideMenuOptions.bind(this);
    this.onLangClick=this.onLangClick.bind(this);
    this.selectLang=this.selectLang.bind(this);
    this.redirectToSignInLoginPage=this.redirectToSignInLoginPage.bind(this);
    this.redirectHome=this.redirectHome.bind(this);
    this.goToDMH=this.goToDMH.bind(this);
    this.showMyProfile=this.showMyProfile.bind(this);
    this.goToOurStory=this.goToOurStory.bind(this);
    // this.goToBlog=this.goToBlog.bind(this);
    this.goToVisavaVendors=this.goToVisavaVendors.bind(this);
    this.checkPaymentStatus=this.checkPaymentStatus.bind(this);
    this.fetchHouseDetails=this.fetchHouseDetails.bind(this);
    this.viewDesignDoc=this.viewDesignDoc.bind(this);
    this.initiatePayment=this.initiatePayment.bind(this);
    this.langSelectOperation=this.langSelectOperation.bind(this);
    this.updateUserProfile=this.updateUserProfile.bind(this);
    this.paymentProcess = this.paymentProcess.bind(this);
    this.redirectPayment=this.redirectPayment.bind(this);
    this.goToHomeListing=this.goToHomeListing.bind(this);
    this.skipPayment=this.skipPayment.bind(this);
    this.continueDoc=this.continueDoc.bind(this);
    this.validateInput=this.validateInput.bind(this);
    this.validateEmail=this.validateEmail.bind(this);
    this.validateMobile=this.validateMobile.bind(this);
    this.fetchProfileDetails=this.fetchProfileDetails.bind(this);
    this.initiatePaymentcall=this.initiatePaymentcall.bind(this);
    this.gateWaycheck=this.gateWaycheck.bind(this);

    this.state = {
      didMouseEnter: false,
      showSideMenuOptions: false,
      showAvailablelang: false,
      showErrorPopUp: false,
      isLoading: false,
      showPayOpt: false,
      bomCost:'999',
      isDocumentFree: FREE_DOCUMENT_FOR_ALL,
      isPaymentCompleted: false,
      orderId: false,
      payParams:{},
      paymentURL: '',
      openHouse: false,
      paymentStarted: false,
      openHouseTotal: false,
      totalHouse: null,
      permittedHouse: null,
      email: '',
      mobile: null,
      mobileValidation: true,
      emailValidation: true,
      showDisable: false,
      preferredLanguage: localStorage.getItem('lang')
    };
  }

  componentDidMount () {
    const jwtToken = localStorage.getItem('jwtToken');
    const isPaymentStarted = localStorage.getItem('isPaymentStarted');
    const path = this.props.location.pathname;

    if(jwtToken) {
      // reading current url
      const currentPage = location.pathname.includes('home-details');
      // clear localStorage DesignDocPrice if url is changed

      if(!currentPage) {
        if(localStorage.getItem('DesignDocPrice')) {
          localStorage.removeItem('DesignDocPrice');
        }
      } else {
        localStorage.setItem('visited', 'visited');
      }

      const visitedPages = localStorage.getItem('visited');
      if(visitedPages) {
        localStorage.removeItem('visited');
        this.fetchProfileDetails();
      }

    }
   
    const headerDataElement = ROUTES.filter((element) => {
      if (location.pathname.includes(element.path) && element.path != '/') {
        return element;
      }
    });

    const headerData = headerDataElement && headerDataElement[0] && headerDataElement[0].headerData;
    const showPayment = headerData && headerData.showPayment;
    if(showPayment) {
      this.setState({
        showPayOpt:true
      });
      this.fetchHouseDetails();
    }
    
  }

  fetchHouseDetails () {
    const houseId = localStorage.getItem('houseId');
    const url = `${API_URL.house}/${houseId}`;

    axiosInstance.get(url).then((resp) => {
      const data = resp && resp.data && resp.data.data;
      if (data) {
        this.setState({
          isPaymentCompleted: data.payment,
          bomCost: data.iap_house_bom_cost,
          isDocumentFree: !!data.is_document_free || this.state.isDocumentFree,
          totalHouse: data.total_house_count,
          permittedHouse: data.maximum_house_count
        });
      }
    }).catch((err) => {
      console.log('err---->>>', err);
    });
  }

  validateInput (e) {
    const { mobile } = this.state;
    if(mobile) {
      this.validateEmail();
    } else {
      this.validateMobile();
    }
  }

  validateEmail () {
    this.setState({
      email: this.state.email,
      emailValidation: true
    });
  }

  validateMobile () {
    this.setState({
      mobile: this.state.mobile,
      mobileValidation: true
    });
  }

  initiatePayment (value) {
    if(this.state.paymentContact == null && value != null) {
      if(!this.state.mobile) {
        if(!value || value.length != 10 ) {
          if(!this.state.mobile) {
            this.setState({
              mobileValidation: false
            });
          }
        } else {
          this.initiatePaymentcall(value);
        }
      } else {
        this.initiatePaymentcall(value);
      }
    } else if(this.state.paymentContact != null) {
      this.initiatePaymentcall(value);
    }
  }


  // payment initiate API call
  initiatePaymentcall (value) {
    const url = BASE_URL_V4 + API_URL.payment;
    const { t } = this.props;
    const houseIdRaw = localStorage.getItem('houseId');
    const object = {
      os_type: 'WEB',
      payment_contact : !value? this.state.paymentContact : value
    };
    if (houseIdRaw) {
      const hid = parseInt(houseIdRaw, 10);
      if (!Number.isNaN(hid)) {
        object.house_id = hid;
      }
    }

    axiosInstance.post(url, object).then((response) => {
      if (response && response.data && response.data.data) {
        const data = response && response.data && response.data.data;
        const formData = {
          url: data.url,
          mid: data.mid,
          orderId: data.order_id,
          transactionToken: data.paytm_txn_token
        };
        this.setState({
          paymentURL: data.url,
          paymentGateway: data.payment_gateway,
          paymentStarted: false,
          mobileValidation: true,
          // mobile: null
        });
        this.gateWaycheck();
        localStorage.setItem('isPaymentStarted', true);
        this.props.setInitialPayment(formData);
        localStorage.setItem('orderId', data.order_id);
      }
    }).catch((err) => {
      console.log('\n\nError in payment------>>', err && err.response && err.response.data);
      if (err && err.response) {
        const errorCodesSuccess = [5001, 5007];
        const errorCodes = [5003, 5004, 5005, 5006, 5007];
        const errData = err.response && err.response.data;
        if (errData && errData.status && errData.status.toLowerCase() == 'failed' && errorCodesSuccess.includes(errData.error_code)) {
          const { location } = this.props;
          const prevPage = location && location.state && location.state.from;
          if(prevPage === 'homes'|| prevPage === 'design-my-house') {
            this.setState({
              showErrorPopUp: false
            });
          } else {
            this.setState({
              showSuccess: true,
              paymentStarted: false,
            });
          }
          localStorage.removeItem('orderId');
        } else if (errData && errData.status && errData.status.toLowerCase() == 'failed' && errorCodes.includes(errData.error_code)) {
          this.setState({
            emailValidation: false
          });
        } else {
          this.setState({
            mobileValidation: false,
          });
        }
      }
    });
  }

  gateWaycheck () {
    this.setState({
      isLoading: false
    });
    if( this.state.paymentGateway == 'EASEBUZZ') {
      this.redirectPayment();
    } else if (this.state.paymentGateway == 'PAYTM') {
      this.redirectPayment();
    } else {
      this.redirectPayment();
      //this.viewDesignDoc();
    }
  }

  checkPaymentStatus () {
    const url = BASE_URL_V4 + API_URL.paymentStatus;
    const object = {
      order_id: localStorage.getItem('orderId')
    };

    axiosInstance.post(url, object).then((response) => {
      if (response && response.data) {
        const data = response && response.data;
        if(data.status === 'SUCCESS') {
          this.setState({
            isPaymentCompleted: true,
            showSuccess: true,
            isPaymentStarted: false,
            showDisable: false
          });
          localStorage.removeItem('orderId');
          this.fetchHouseDetails();
        } else if(data.status=='FAILURE' || (data.status=='PENDING')) {
          this.setState({
            showDisable: true,
            isPaymentCompleted: false,
            showSuccess: false,
            showErrorPopUp: true,
            isPaymentStarted: false
          });
          //this.initiatePayment();
        }
      }
    }).catch((err) => {
      console.log('\n\nError in payment------>>', err && err.response && err.response.data);
    });
  }

  viewDesignDoc () {
    //localStorage.setItem('isValid', true);
    const houseId = localStorage.getItem('houseId');
    const shareToken = localStorage.getItem('shareToken');
    const langCode = localStorage.getItem('lang');
    const { history } = this.props;
    history && history.push(`/design-document?house_id=${houseId}&share_token=${shareToken}&preferred_language=${langCode}&user_agent=${userAgent}`);
  }

  onEnter () {
    this.setState({
      didMouseEnter: true
    });
  }

  onLeave () {
    this.setState({
      didMouseEnter: false
    });
  }

  renderSideMenuOptions () {
    this.setState({
      showSideMenuOptions: !this.state.showSideMenuOptions,
      showAvailablelang: false,
    });
  }

  onLangClick () {
    this.setState({
      showAvailablelang: true
    });
  }

  goToHomeListing () {
    const { history } = this.props;
    history.push('/homes');
  }

  continueDoc () {
    this.setState({
      paymentStatus: this.state.paymentStarted,
      showSuccess: false
    });
    this.goToHomeListing();
  }

  updateUserProfile () {
    const URL = BASE_URL_V4 + API_URL.getUserProfile;
    const payloadObject = {
      preferred_language: localStorage.getItem('lang'),
      first_name: '',
      last_name: ''
    };
    axiosInstance
      .patch(URL, payloadObject)
      .then(() => {
        this.fetchProfileDetails();
      })
      .catch((err) => {
        console.log('\n\n\nError----------->>>>', err.response);
      });
      
  }

  langSelectOperation (lang) {
    //this.selectLang(lang);
    const jwtToken = localStorage.getItem('jwtToken');
    if(jwtToken) {
      this.selectLang(lang);
      this.updateUserProfile();
    } else {
      this.selectLang(lang);
    }
  }

  selectLang (lang) {
    changeLang(lang);
    this.props.updateLangCode(lang);
    localStorage.setItem('lang', lang);
    this.setState({
      showAvailablelang: false
    });
  }

  redirectToSignInLoginPage (text) {
    this.setState({
      showSideMenuOptions: false,
      showAvailablelang: false
    });
    if (text && text.toLowerCase() == 'log in') {
      this.props.history.push('/login');
    } else {
      this.props.history.push('/signup');
    }
  }

  updateBreakPoint (breakpoint) {
    this.props.updateBreakPoint(breakpoint || 'lg');
  }


  redirectHome () {
    this.setState({
      showSideMenuOptions: false,
      showAvailablelang: false
    });
    this.props.history.push('/');
  }

  goToDMH () {
    const { history } = this.props;
    if (localStorage.getItem('jwtToken')) {
      this.setState({
        showSideMenuOptions: false
      }, () => history.push('/homes'));
    } else {
      history.push('/login');
    }
  }

  showMyProfile () {
    const { history } = this.props;
    this.setState({
      showSideMenuOptions: false,
      showAvailablelang: false,
    });
    history && history.push('/my-profile');
  }

  goToOurStory () {
    const { history } = this.props;
    this.setState({
      showSideMenuOptions: false,
      showAvailablelang: false,
    });
    history && history.push('/our-story');
  }

  goToVisavaVendors () {
    const { history } = this.props;
    history && history.push('/visava-vendors');
  }

  skipPayment () {
    const url = BASE_URL_V4 + API_URL.payment;
    axiosInstance.put(url).then((response) => {
      if (response && response.data && response.data.data) {
        const data = response && response.data && response.data.data;
        this.setState({
          //showSuccess: true,
          paymentStatus: 'SUCCESS'
        });
        this.viewDesignDoc();
      }
    }).catch((err) => {
      console.log('\n\nError in payment------>>', err && err.response && err.response.data);
      if (err && err.response) {
        const errData = err.response && err.response.data;
        if (errData && errData.status && errData.status.toLowerCase() == 'failed' && errData.error_code === 5401) {
          const { t }=this.props;
          this.setState({
            errorMessage: t('cannot_make_payment_three'),
            buttonLabel: t('close_button'),
            showErrorPopUp: true,
            openHouseTotal: true
          });
          localStorage.removeItem('orderId');
        }
      }
    });
  }

  paymentProcess () {
    const { t } = this.props;
    if(FREE_DOCUMENT_FOR_ALL || this.state.userType === User_Type || this.state.isDocumentFree) {
      this.initiatePaymentcall();
      //this.gateWaycheck();
    } else {
      this.setState({
        // errorMessage: t('noFurtherEdit'),
        //showErrorPopUp: true,
        paymentStarted: true,
        //buttonLabel: t('view_design_doc')
      });
    }
  }

  //User-profile API call
  fetchProfileDetails () {
    const { history } = this.props;
    const jwtToken = localStorage.getItem('jwtToken');
    const { preferredLanguage } = this.state;

    if (!jwtToken) {
      history.push('/');
    } else {
      this.setState({
        loading: true,
      });
      const URL = BASE_URL_V4 + API_URL.getUserProfile;
      axiosInstance
        .get(URL)
        .then((resp) => {
          const profileData = resp && resp.data && resp.data.data;
          const preferredLanguage = profileData.preferred_language;
          if (profileData) {
            this.setState({
              email: profileData.email,
              mobile: profileData.mobile_number,
              countryCode: profileData.country_code,
              paymentContact: profileData.payment_contact,
              preferredLanguage: profileData.preferred_language,
              userType: profileData.user_type,
              isDocumentFree: !!profileData.is_document_free || this.state.isDocumentFree
            });
          }
          if(preferredLanguage) {
            this.selectLang(preferredLanguage);
            //this.updateUserProfile();
            //this.props.history.push('/');
          } else {
            this.selectLang(localStorage.getItem('lang'));
          }
        })
        .catch((err) => {
          this.setState({
            loading: false,
          });
          console.log(err, 'Error');
          if(err.response.data.status == 'Token is Expired' || err.response.data.status == 'Token is Invalid' || err.response.data.status == 'Authorization Token not found') {
            localStorage.clear();
            this.props.history.push('/login', { expiredError: true });
          }
        });
    }
  }

  redirectPayment () {
    const { paymentURL } = this.state;
    localStorage.setItem('isPaymentStarted', true);
    window && window.open(paymentURL);
    if (paymentURL && String(paymentURL).indexOf('design-document') !== -1) {
      this.goToHomeListing();
    }
  }

  // goToBlog () {
  //   const langCode = localStorage.getItem('lang');
  //   if(langCode == 'en') {
  //     windowOpenHandler(`${BLOG_URL}`);
  //   } else {
  //     windowOpenHandler(`${BLOG_URL}/${langCode}`);
  //   }
  // }

  render () {
    const { t, breakpoint, langCode } = this.props;
    const { didMouseEnter, showDisable, showSideMenuOptions, paymentContact, paymentStarted, totalHouse, permittedHouse, showAvailablelang, isPaymentCompleted, showPayOpt, bomCost, isDocumentFree, isLoading, mobile } = this.state;
    const { payParams } = this.props;
    const { children, location } = this.props;
    const myState = location && location.state;

    const headerDataElement = ROUTES.filter((element) => {
      if (element && element.path && element.path.includes(location.pathname)) {
        return element;
      }
    });
    const headerData = headerDataElement && headerDataElement[0] && headerDataElement[0].headerData;
    const from = (headerData && headerData.page == 'otp') && (location && location.state && location.state.from);
    const showTopbtn = breakpoint == 'lg' && (headerData && headerData.btnText != undefined);
    const btnText = (from && from == 'signup') ? 'LOG IN' : from && from == 'login' ? 'SIGN UP' : (headerData && headerData.btnText) || 'SIGN UP';
    const buttonText = btnText.toUpperCase() == 'log in' ?
      t('login') : t('sign_up');

    const jwtToken = localStorage.getItem('jwtToken');
    const showHeader = headerData && headerData.showHeader;
    const isDMH = headerData && headerData.dmh;
    //read from props and change the name(enablehumburgerheader)>>>>>>>>>
    const showPayment = headerData && headerData.showPayment;
    
    return (
      <><Loader
        isLoading={isLoading} />
        <Fragment>
          <div>
            {showHeader && <div className={'header-container-1'}>
              <div className='logoWrapper'
                style={isDMH ? { width: '100%' } : undefined}>
                <div>
                  <div className='logoContainer'
                    onClick={this.redirectHome}>
                    <img
                      className='logo'
                      src={VisavaLogo}
                      alt={'VisavaLogo'} />
                  </div>
                  {breakpoint == 'lg' && <div className='brand_name'>
                    {t('app_name').toUpperCase()}
                    {WebApp_VERSION == 'BETA' ?
                      <div className='beta-txt'>BETA</div> : null }
                  </div>}
                </div>
                {(isDMH && breakpoint == 'lg') && <div className={`${'design-house-text'} ${showPayment && 'design-header-center'}`}>{t('design_my_house').toUpperCase()}</div>}
              </div>
              <div className='headerLinksContainer'>
                {breakpoint == 'lg' && !isDMH && <div className='header-link-wrapper'>
                  <span className='headerLinks'
                    onClick={this.goToDMH}>
                    {t('design_my_house')}
                  </span>
                  <span className='headerLinks'
                    onClick={this.goToOurStory}>
                    {t('our_story')}
                  </span>
                  {/* <span className='headerLinks'
                    onClick={this.goToBlog}>
                    {t('blog')}
                  </span> */}
                  {jwtToken &&
                    <span
                      className={`headerLinks${SHOW_HEADER_MY_PROFILE_LINK ? '' : ' visava-header-temp-hidden'}`}
                      onClick={this.showMyProfile}>
                      {t('my_profile')}
                    </span> }
                  <span className='headerLinks'
                    onClick={this.goToVisavaVendors}>
                    {t('visava_vendor')}
                  </span>
                  <span className='headerLinks'
                    onClick={this.onLangClick}>
                    <img className='langLogo'
                      src={languageLogo}
                      alt='languageLogo' />
                    {t('selected_lang')}
                  </span>
                </div>}
                {/*breakPoint_L && showPayment && <div className='header-link-wrapper'>
                  <img className='image'
                    src={GetDocumentImg}
                    alt='' />   
                  </div> */}
                {breakpoint == 'lg' && (showPayOpt || showPayment) ?
                  // !isPaymentCompleted || totalHouse < 3 ?
                  totalHouse < permittedHouse ?
                    <>{showDisable ? <div className='pending_status'>{t('process_payment')}</div> : null }
                      <div style={{ position: 'relative' }}>
                        {/* <div className='offer_tag_img'><img src={Offer_tag_img}
                        alt='offer' /></div> */}
                        {WebApp_VERSION == 'BETA' ?
                          langCode == 'en' ?
                            <><div className='offer_tag_img' /><div className='offer_tag_img'>
                              <img src={betaOffer}
                                alt='offer' />
                            </div></> : <><div className='offer_text' /><div className='offer_tag_img_hi_mi'>
                              <img src={betaOffer}
                                alt='offer' />
                            </div></> : null}
                        <div className='get-document-header'
                          onClick={ showDisable ? '' : this.paymentProcess}>
                          {isDocumentFree ?
                            <button className='get-document-submit button-pointer'
                              onClick={this.paymentProcess}>{t('get_document_for_free')}</button>
                            : WebApp_VERSION == 'BETA' ?
                              langCode == 'en' ?
                                <button className='get-document-submit button-pointer'
                                  onClick={this.paymentProcess}>{t('get_document_starting')} <span className='original_price'>₹{bomCost}</span></button> :
                                <button className='get-document-submit button-pointer'
                                  onClick={this.paymentProcess}><span className='original_price'>₹{bomCost}</span> {t('get_document_starting')} </button>
                              : langCode == 'en' ?
                                <button className='get-document-submit button-pointer'
                                  onClick={this.paymentProcess}>{t('get_document_starting')} <span>₹{bomCost}</span></button> :
                                <button className='get-document-submit button-pointer'
                                  onClick={this.paymentProcess}><span>₹{bomCost}</span> {t('get_document_starting')} </button>}
                        </div>
                      </div>
                    </> : null
                  // <div className='get-document-header button-pointer'
                  //   onClick={this.viewDesignDoc}>
                  //   {t('view_design_doc')}
                  // </div>
                  : null }
                {jwtToken && !isDMH ?
                  <div
                    className={`playStore-container${SHOW_HEADER_GOOGLE_PLAY_BADGE ? '' : ' visava-header-temp-hidden'}`}>
                    <a href={GOOGLE_PLAY_URL}
                      target='_blank'
                      rel='noopener noreferrer'><img className='playStoreImg'
                        src={langCode == 'hi' ? GooglePlayBadgeHi : langCode == 'mr' ? GooglePlayBadgeMa : GooglePlayBadgeEn}
                        alt='' /></a>
                  </div> : !isDMH &&
                    <div
                      className={`${'loginButton'} ${didMouseEnter && 'loginButtonHover'} ${(showTopbtn) && 'hidecomponent'}`}
                      onMouseEnter={this.onEnter}
                      onMouseLeave={this.onLeave}
                      onClick={() => this.redirectToSignInLoginPage(btnText)}
                      role='button'>
                      {buttonText}
                    </div>}
                {(!isDMH && breakpoint !== 'lg') && <div className='icon-wrapper opt-link'
                  onClick={this.renderSideMenuOptions}>
                  <img className={`${showSideMenuOptions ? 'close-icon' : 'side-menu'}`}
                    src={showSideMenuOptions ? CloseIcon : SideMenuIcon}
                    alt='' />
                </div>}
                {((isDMH && breakpoint == 'sm') || (isDMH && breakpoint == 'lg')) && <div className='icon-wrapper opt-link'
                  onClick={this.renderSideMenuOptions}>
                  <img className={`${showSideMenuOptions ? 'close-icon' : 'side-menu'}`}
                    src={showSideMenuOptions ? CloseIcon : SideMenuIcon}
                    alt='' />
                </div>}
              </div>
            </div>}
            {showSideMenuOptions && !showAvailablelang && showHeader ?
              <div className='sideMenu-options'>
                <div className='options opt-link'
                  onClick={this.goToDMH}>{t('design_my_house')}</div>
                <div className='options opt-link'
                  onClick={this.goToOurStory}>{t('our_story')}</div>
                {/* <div className='options'
                  onClick={this.goToBlog}>{t('blog')}
                </div> */}
                {jwtToken && <div
                  className={`options opt-link${SHOW_HEADER_MY_PROFILE_LINK ? '' : ' visava-header-temp-hidden'}`}
                  onClick={this.showMyProfile}>{t('my_profile')}</div>}
                <div className='options opt-link'
                  onClick={this.goToVisavaVendors}>{t('visava_vendor')}</div>
                <div onClick={this.onLangClick}
                  style={{
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                  <div className='lang_icon'>
                    <img
                      src={languageLogo}
                      alt='languageLogo' />
                  </div>
                  <div style={{
                    marginBottom: '0',
                    lineHeight: 'normal'
                  }}
                    className='options opt-link'>{t('selected_lang')}</div>
                </div>
              </div> :
              showAvailablelang && showHeader ?
                <div className='sideMenu-options'>
                  <div className='options'><div>{t('select_lang')}</div><div onClick={this.redirectHome}
                    className='close_icon' /></div>
                  <div className='languages'>
                    <div onClick={() => this.langSelectOperation('hi')}
                      className='options opt-link'
                      style={langCode.toLowerCase() == 'hi' ? {
                        color: '#00B0A6',
                        fontWeight: '600'
                      } : {}}>हिन्दी</div>
                    <div onClick={() => this.langSelectOperation('en')}
                      className='options opt-link'
                      style={langCode.toLowerCase() == 'en' ? {
                        color: '#00B0A6',
                        fontWeight: '600'
                      } : {}}>English</div>
                    <div onClick={() => this.langSelectOperation('mr')}
                      className='options opt-link'
                      style={langCode.toLowerCase() == 'mr' ? {
                        color: '#00B0A6',
                        fontWeight: '600'
                      } : {}}>मराठी</div>
                  </div>
                </div> :
                <div className='dummy-class'>
                  {children}
                </div>}
          </div>
          <Breakpoint onBreakpointChange={this.updateBreakPoint} />
        </Fragment>
        <div>
          {this.state.showSuccess &&
            <PaymentSuccessPage continueDoc={this.continueDoc} /> }
          {paymentStarted && <PaymentPopup
            close={() => this.setState({ paymentStarted:false,
              mobileValidation:true,
              emailValidation:true })}
            cardDescribtion={(mobile ? 'enter_email_id' : 'enter_phone_num_descrb')}
            buttonHeader={(mobile ? t('Email_ID') : t('phone_number'))}
            formOpen={this.initiatePayment}
            placeholderValue={paymentContact ? paymentContact : ''}
            value={this.state.value}
            validations={this.validateInput}
            cardError={ this.state.mobileValidation && this.state.emailValidation ? '' : !this.state.mobileValidation ? t('enter_phone_num') : t('enter_valid_inputs')} />}
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setInitialPayment: (data) => {
    dispatch(setInitialPayment(data));
  },
  updateBreakPoint: (breakpoint) => {
    dispatch(updateBreakPoint(breakpoint));
  },
  updateLangCode: (lang) => {
    dispatch(updateLangCode(lang));
  }
});

const mapStateToProps = (state) => ({
  payParams: (state.homeDetailsState && state.homeDetailsState.payParams) || {},
  breakpoint : getBreakpoint(state),
  langCode: getLangCodeSelector(state)
});


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withRouter(Header)));
